import { useMemo } from 'react';
import DashboardBody from '../dashboard-body/dashboard-body';
import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';
import DashboardGrid from '@/components/dashboard/dashboard-grid/dashboard-grid';
import Resources from '@/components/resources/resources';
import HealthDataContent from '../../../health-data/components/health-data-content/health-data-content';
import { Tab, TabType } from '../../../health-data/types';
import { HealthDataHero } from '@/app/components/health-data/components/health-data-hero/health-data-hero';
import { CatchLabsCTA } from '@/app/components/common/CatchLabsCTA';
import { LabOrderListResponse } from '@/api/generated-catch-backend/model';

interface UseDashboardTabsConfigProps {
  setParams: (params: Record<string, string>) => void;
  labOrdersData?: LabOrderListResponse;
  isEligibleForLabOrder?: boolean;
}

export function useDashboardTabsConfig({ setParams, labOrdersData, isEligibleForLabOrder }: UseDashboardTabsConfigProps) {
  const tabsConfig: Record<TabType, Tab> = useMemo(
    () => ({
      'risk-insights': {
        id: 'risk-insights' as TabType,
        label: 'Risk Insights',
        tabContent: (
          <DashboardBody labOrdersData={labOrdersData} isEligibleForLabOrder={isEligibleForLabOrder}>
            {/* CatchLabsCTA: shows in sidebar on desktop, as 3rd card on mobile */}
            <div className="hidden lg:block">
              <CatchLabsCTA />
            </div>
            <Resources as="aside" width="full" />
          </DashboardBody>
        ),
      },
      'health-data': {
        id: 'health-data' as TabType,
        label: 'Health Data',
        tabContent: (
          <DashboardLayout>
            <DashboardGrid>
              <HealthDataContent setParams={setParams} />
              <Resources as="aside" width="full" />
            </DashboardGrid>
          </DashboardLayout>
        ),
        heroContent: <HealthDataHero />,
      },
    }),
    [setParams, labOrdersData, isEligibleForLabOrder],
  );

  return { tabsConfig };
}
